export default class AutoCompleteClient {
  constructor(
    private endpoint: string,
    private language: string,
  ) {}

  public GetItems = (term: string, signal?: AbortSignal): Promise<string[]> => {
    const query = new URLSearchParams({ language: this.language, term });
    return fetch(`${this.endpoint}?${query}`, { signal }).then((response) => {
      if (!response.ok) throw new Error("Error from search API");
      return response.json();
    });
  };
}
